module.exports = __webpack_public_path__ + "img/white.62c1e4d4.png";